import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../../../common/html/element'
import { Table } from '../../../../../common/table'
import { FinancialStatementsValueCell } from '../../common/table/FinancialStatementsValueCell'
import { MultiTHead } from '../../common/table/MultiTHead'

import { useLocation } from 'react-router'
import { selectCompanyInfo } from '../../../../common/header/companyInfo/store/slice'
import { FilterTable } from '../../common/filterTable/FilterTable'
import { FirstColumnCell } from '../../common/table/firstColumnCell/FirstColumnCell'
import { AUDIT_STATUS, TYPE_OF_FS } from '../../constant'
import {
  changeAuditStatus,
  changeBalanceSheetIds,
  selectAuditStatuses,
  selectBalanceSheetChildIds,
  selectBalanceSheetIds,
  selectBalanceSheetItem,
  selectBalanceSheetParentId,
  selectBalanceSheetRowData,
  selectDataYears,
  selectGroupColumns,
  selectIsLoading,
  selectIsShowCommonSize,
  selectMethods,
  selectSource,
  selectTypeOfFS,
} from '../../store/slice'
import { financialStatementsOneYearTable } from '../../store/thunk'
import classes from './BalanceSheet.module.scss'

export const BalanceSheet = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const balanceSheetIds = useSelector(selectBalanceSheetIds)
  const groupColumns = useSelector(selectGroupColumns)
  const auditStatuses = useSelector(selectAuditStatuses)
  const methods = useSelector(selectMethods)
  const isLoading = useSelector(selectIsLoading)
  const isShowCommonSize = useSelector(selectIsShowCommonSize)
  const source = useSelector(selectSource)
  const typeOfFS = useSelector(selectTypeOfFS)
  const dataYears = useSelector(selectDataYears)

  const organizationIdParams = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  }).organizationId

  const companyInfo = useSelector(selectCompanyInfo)
  const companyType = companyInfo.companyType

  const onChangeAuditStatus = (e, year) => {
    const statusChange = auditStatuses.find((status) => status.year === year)
    const statusNotChange = auditStatuses.filter(
      (status) => status.year !== year,
    )
    const newAuditStatus = [
      ...statusNotChange,
      { year: year, isAudit: e.value === AUDIT_STATUS.audited.value },
    ]

    if (statusChange.isAudit !== (e.value === AUDIT_STATUS.audited.value)) {
      dispatch(
        financialStatementsOneYearTable({
          organizationId: Number(organizationIdParams),
          sourceOrganizationId: source.value,
          isConsolidated: typeOfFS.value === TYPE_OF_FS.consolidated.value,
          years: dataYears,
          auditStatuses: newAuditStatus,
          methods: methods,
        }),
      )
      dispatch(changeAuditStatus(newAuditStatus))
    }
  }

  return (
    <Element className={classes.container}>
      <FilterTable
        auditStatuses={auditStatuses}
        methods={methods}
        ids={balanceSheetIds}
      />
      <Element className={classes.tableContainer}>
        <Table
          ids={balanceSheetIds}
          getDataFromRedux={selectBalanceSheetItem}
          noDataText={'common.NO_DATA'}
          isLoading={isLoading}
          isNoDataWithHead={true}
          isDisplayScroll={false}
          renderTHead={() => (
            <MultiTHead
              tableTitle={groupColumns}
              tabName={'balanceSheet'}
              onChangeAuditStatus={onChangeAuditStatus}
            />
          )}
          schema={
            groupColumns[0]
              ? groupColumns[0].map((item, index) => {
                  const title = item.title
                  const colId = `${item.colId}`

                  const result = {
                    title,
                    colId,
                  }
                  if (index === 0) {
                    return {
                      ...result,
                      render: (val, { rowId }) => {
                        return (
                          <FirstColumnCell
                            ids={balanceSheetIds}
                            rowId={rowId}
                            val={val}
                            selectRowData={selectBalanceSheetRowData}
                            selectChildIds={selectBalanceSheetChildIds}
                            selectParentIds={selectBalanceSheetParentId}
                            changeIds={changeBalanceSheetIds}
                            tabName="balanceSheets"
                          />
                        )
                      },
                    }
                  }

                  return {
                    ...result,
                    render: (val, { locale }) => {
                      return (
                        <FinancialStatementsValueCell
                          val={val}
                          locale={locale}
                          isShowCommonYoY={isShowCommonSize}
                          tabName="balanceSheets"
                          companyType={companyType}
                          colId={colId}
                        />
                      )
                    },
                  }
                })
              : []
          }
        />
      </Element>
    </Element>
  )
}
